/**
 * "Where did you hear about us?" from the intro tour's last slide.
 *
 * People who aren't signed in yet answer before they have an account, so the
 * answer waits on the device and is sent once they're signed in. The server
 * keeps the first answer per user.
 */
import { apiRequest } from "./queryClient";
import type { HeardFrom } from "@/pages/intro/scenes";

const KEY = "spliiit_heard_from";

export function rememberHeardFrom(answer: { source: HeardFrom; detail?: string }): void {
  try { localStorage.setItem(KEY, JSON.stringify(answer)); } catch { /* storage off */ }
}

let sending = false;

/** Sends a waiting answer. Safe to call often; a no-op when nothing is waiting. */
export async function syncHeardFrom(): Promise<void> {
  let raw: string | null = null;
  try { raw = localStorage.getItem(KEY); } catch { return; }
  if (!raw || sending) return;
  sending = true;
  try {
    await apiRequest("POST", "/api/user/heard-from", JSON.parse(raw));
    try { localStorage.removeItem(KEY); } catch { /* storage off */ }
  } catch (e) {
    // A 400 means the stored answer is bad; drop it. Anything else (offline,
    // signed out) tries again next time.
    if (String((e as Error)?.message ?? e).startsWith("400")) { try { localStorage.removeItem(KEY); } catch { /* storage off */ } }
  } finally {
    sending = false;
  }
}
